module.exports = __webpack_public_path__ + "eeef7ccbfed51a680aa0a6e8661ebda6.svg";